import { FormlyFieldConfig } from '@ngx-formly/core';
import { LuFormlyBuilder } from '../formly.builder';
import { FieldType, InputType } from './formly-builder.models';

export class LuFormlyInputBuilder extends LuFormlyBuilder {
	protected type = FieldType.INPUT;
	protected inputType = InputType.TEXT;
	private minLength: number = null;
	private maxLength: number = null;
	private maxLengthMessage = false;
	private maxLengthLimit: number;
	private minLengthMessage = false;
	private afterText: string;
	private afterTextClass: string;
	private beforeText: string;
	private beforeTextClass: string;

	public setInputType(inputType: InputType): this {
		this.inputType = inputType;
		return this;
	}

	public setMinLength(minLength: number): this {
		this.minLength = minLength;
		return this;
	}

	public setAfterText(afterText: string, afterTextClass: string = ''): this {
		this.afterText = afterText;
		this.afterTextClass = afterTextClass;
		return this;
	}

	public setBeforeText(beforeText: string, beforeTextClass: string = ''): this {
		this.beforeText = beforeText;
		this.beforeTextClass = beforeTextClass;
		return this;
	}

	public setMaxLength(maxLength: number): this {
		this.maxLength = maxLength;
		return this;
	}

	/**
	 * In this method, the second argument is optional and represents the threshold of the remaining characters.
	 * The acceptable types are number and null.
	 * If this argument is omitted, the remaining character's label will only be visible
	 * when that number of remaining characters goes below 200.
	 * If a valid number is provided, it will take precedence over the default value.
	 * In the case of the 'null' value, it will show the label all the time.
	 */
	public setMaxLengthMessage(maxLengthMessage: boolean, maxLengthLimit?: number | null): this {
		this.maxLengthLimit = maxLengthLimit === undefined ? 200 : maxLengthLimit;
		this.maxLengthMessage = maxLengthMessage;
		return this;
	}

	public setMinLengthMessage(minLengthMessage: boolean): this {
		this.minLengthMessage = minLengthMessage;
		return this;
	}

	public build(): FormlyFieldConfig {
		const field = super.build();

		field.templateOptions.type = this.inputType;
		if (this.minLength !== null) {
			field.templateOptions.minLength = this.minLength;
		}

		if (this.maxLength !== null) {
			field.templateOptions.maxLength = this.maxLength;
		}

		if (this.maxLengthMessage != null) {
			field.templateOptions.maxLengthMessage = this.maxLengthMessage;
			field.templateOptions.maxLengthLimit = this.maxLengthLimit;
		}

		if (this.minLengthMessage != null) {
			field.templateOptions.minLengthMessage = this.minLengthMessage;
		}

		field.templateOptions.afterText = this.afterText;
		field.templateOptions.afterTextClass = this.afterTextClass;

		field.templateOptions.beforeText = this.beforeText;
		field.templateOptions.beforeTextClass = this.beforeTextClass;

		return field;
	}
}
